import {getService} from "@project/sdk/engineering";
import {GetServiceResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {serviceKeys} from "../../../service-keys";

export function getServiceQueryOptions(id: string, includeDeleted = false) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...serviceKeys.detail(id), {includeDeleted}] as const,
    queryFn: async ({signal}) =>
      GetServiceResponse.parse(await getService(id, {includeDeleted}, {signal})),
  });
}
